export const COLORS = {
    navy: '#00229e',
    blue: '#2957c4',
    aqua: '#19c3d6',
    teal: '#05827d',
    olive: '#006333',
    green: '#05914d',
    lime: '#12bc6b',
    yellow: '#cc9918',
    orange: '#dd7d0f',
    red: '#af1c1c',
    pink: '#d14db0',
    fuchsia: '#bc2990',
    purple: '#a31578',
    maroon: '#7c0606',
    white: '#ffffff',
    lightgray: '#b5b5b5',
    lightgrey: '#b5b5b5',
    gray: '#969696',
    grey: '#969696',
    darkgray: '#323232',
    darkgrey: '#323232',
    black: '#111111',
};
